export default __webpack_public_path__ + "static/media/4035.376212bd.png";